// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.task-settings-modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.task-settings-modal-wrapper.disabled {
  pointer-events: none;
}
.task-settings-modal-wrapper .task-settings-modal {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #515554;
  width: 280px;
  padding: 1.8rem 1.2rem 1.5rem;
  overflow: hidden;
  box-shadow: 1px 3px 8px -1px #9c9c9c;
  position: relative;
}
.task-settings-modal-wrapper .task-settings-modal.disabled::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}
.task-settings-modal-wrapper .task-settings-modal__header {
  color: #696969;
  padding-left: 0.5rem;
}
.task-settings-modal-wrapper .task-settings-modal__header .header-with-icon {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.task-settings-modal-wrapper .task-settings-modal__header .header-with-icon .header-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.task-settings-modal-wrapper .task-settings-modal__body {
  padding-top: 1rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.9rem 0;
  border-bottom: 1px solid #efefef;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .option-label {
  flex: 1;
  font-size: 1.4rem;
  color: #696969;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .option-label__rollover {
  margin-left: 0.9rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .task-rollover-checkbox {
  margin: 0;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .material-icons {
  margin-left: unset;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .material-icons.repeat-icon {
  color: #9c9c9c;
  margin-right: 0.6rem;
  font-size: 1.9rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .material-icons.repeat-icon--active {
  color: #dabc64;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .material-icons-outlined.repeat-chevron {
  color: #9c9c9c;
  margin-left: auto;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .material-icons-outlined.add-alarm-chevron {
  color: #9c9c9c;
  margin-left: auto;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row .add-alarm-icon {
  width: auto;
  height: 1.9rem;
  margin-right: 0.6rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row {
  cursor: default;
  border-bottom: 1px solid #efefef;
  width: 99%;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row .alarm-display-icon {
  width: auto;
  height: 1.9rem;
  margin-right: 0.6rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row .alarm-display-icon path {
  stroke: #dabc64;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row .alarm-datetime {
  flex: 1;
  font-size: 1.4rem;
  color: #696969;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row .alarm-delete-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #9c9c9c;
  display: flex;
  align-items: center;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.alarm-display-row .alarm-delete-button .material-icons-outlined {
  font-size: 2rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .option-row.add-another-alarm-row .option-label {
  padding-left: 2.1rem;
}
.task-settings-modal-wrapper .task-settings-modal__body .artful-checkbox-wrapper {
  padding-left: 1.2em;
}
.task-settings-modal-wrapper .task-settings-modal__body .artful-checkbox-wrapper label::before {
  left: 11%;
  top: 0.18rem;
  font-size: 1.7rem;
  color: #9c9c9c;
}
.task-settings-modal-wrapper .task-settings-modal__body .artful-checkbox-wrapper .checked::before {
  color: #dabc64;
}
.task-settings-modal-wrapper .task-settings-modal__buttons {
  display: flex;
  padding-top: 1.5rem;
}
.task-settings-modal-wrapper .task-settings-modal__buttons .btn {
  flex: 1;
  text-align: center;
  font-size: 1.2rem;
  padding: 0.8rem 0;
  border: none;
}
.task-settings-modal-wrapper .task-settings-modal__buttons .spacer {
  width: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/ChecklistsDisplay/TaskSettingsModal.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aC0Be;EDzBf,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EACE,oBAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EAEA,yBDVc;ECWd,yBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AAAJ;AAGM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,oBAAA;AADR;AAKI;EACE,cDzCU;EC0CV,oBAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAHR;AAKQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAHV;AAQI;EACE,iBAAA;AANN;AAQM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gCAAA;AANR;AAQQ;EACE,OAAA;EACA,iBAAA;EACA,cDtEM;ACgEhB;AAQU;EACE,mBAAA;AANZ;AAUQ;EACE,SAAA;AARV;AAWQ;EACE,kBAAA;AATV;AAWU;EACE,cDrEA;ECsEA,oBAAA;EACA,iBAAA;AATZ;AAWY;EACE,cD3EP;ACkEP;AAeU;EACE,cDjFA;ECkFA,iBAAA;AAbZ;AAgBU;EACE,cDtFA;ECuFA,iBAAA;AAdZ;AAkBQ;EACE,WAAA;EACA,cAAA;EACA,oBAAA;AAhBV;AAmBQ;EACE,eAAA;EACA,gCAAA;EACA,UAAA;AAjBV;AAmBU;EACE,WAAA;EACA,cAAA;EACA,oBAAA;AAjBZ;AAkBY;EACE,eD5GP;AC4FP;AAoBU;EACE,OAAA;EACA,iBAAA;EACA,cDlII;ACgHhB;AAqBU;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cD1HA;EC2HA,aAAA;EACA,mBAAA;AAnBZ;AAqBY;EACE,eAAA;AAnBd;AAyBU;EACE,oBAAA;AAvBZ;AA4BM;EACE,mBAAA;AA1BR;AA4BU;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,cDlJA;ACwHZ;AA8BU;EACE,cDxJL;AC4HP;AAkCI;EACE,aAAA;EACA,mBAAA;AAhCN;AAkCM;EACE,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AAhCR;AAmCM;EACE,aAAA;AAjCR","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.task-settings-modal-wrapper {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: $modalBaseLayer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &.disabled {\n    pointer-events: none;\n  }\n\n  .task-settings-modal {\n    display: flex;\n    flex-direction: column;\n\n    background-color: $backgroundColor;\n    border: 1px solid $darkGray;\n    width: 280px;\n    padding: 1.8rem 1.2rem 1.5rem;\n    overflow: hidden;\n    box-shadow: 1px 3px 8px -1px $shadow;\n    position: relative;\n\n    &.disabled {\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(0, 0, 0, 0.5);\n        pointer-events: none;\n      }\n    }\n\n    &__header {\n      color: $darkTextColor;\n      padding-left: 0.5rem;\n\n      .header-with-icon {\n        display: flex;\n        align-items: center;\n        gap: 0.6rem;\n\n        .header-icon {\n          width: 18px;\n          height: 18px;\n          flex-shrink: 0;\n        }\n      }\n    }\n\n    &__body {\n      padding-top: 1rem;\n\n      .option-row {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 0.9rem 0;\n        border-bottom: 1px solid $gray;\n\n        .option-label {\n          flex: 1;\n          font-size: 1.4rem;\n          color: $darkTextColor;\n\n          &__rollover {\n            margin-left: 0.9rem;\n          }\n        }\n\n        .task-rollover-checkbox {\n          margin: 0;\n        }\n\n        .material-icons {\n          margin-left: unset;\n\n          &.repeat-icon {\n            color: $iconColor;\n            margin-right: 0.6rem;\n            font-size: 1.9rem;\n\n            &--active {\n              color: $gold;\n            }\n          }\n        }\n\n        .material-icons-outlined {\n          &.repeat-chevron {\n            color: $iconColor;\n            margin-left: auto;\n          }\n\n          &.add-alarm-chevron {\n            color: $iconColor;\n            margin-left: auto;\n          }\n        }\n\n        .add-alarm-icon {\n          width: auto;\n          height: 1.9rem;\n          margin-right: 0.6rem;\n        }\n\n        &.alarm-display-row {\n          cursor: default;\n          border-bottom: 1px solid $gray;\n          width: 99%;\n\n          .alarm-display-icon {\n            width: auto;\n            height: 1.9rem;\n            margin-right: 0.6rem;\n            path {\n              stroke: $gold;\n            }\n          }\n\n          .alarm-datetime {\n            flex: 1;\n            font-size: 1.4rem;\n            color: $darkTextColor;\n          }\n\n          .alarm-delete-button {\n            background: none;\n            border: none;\n            padding: 0;\n            cursor: pointer;\n            color: $iconColor;\n            display: flex;\n            align-items: center;\n\n            .material-icons-outlined {\n              font-size: 2rem;\n            }\n          }\n        }\n\n        &.add-another-alarm-row {\n          .option-label {\n            padding-left: 2.1rem;\n          }\n        }\n      }\n\n      .artful-checkbox-wrapper {\n        padding-left: 1.2em;\n        label {\n          &::before {\n            left: 11%;\n            top: 0.18rem;\n            font-size: 1.7rem;\n            color: $iconColor;\n          }\n        }\n        .checked {\n          &::before {\n            color: $gold;\n          }\n        }\n      }\n    }\n\n    &__buttons {\n      display: flex;\n      padding-top: 1.5rem;\n\n      .btn {\n        flex: 1;\n        text-align: center;\n        font-size: 1.2rem;\n        padding: 0.8rem 0;\n        border: none;\n      }\n\n      .spacer {\n        width: 1.2rem;\n      }\n    }\n  }\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
